export default __webpack_public_path__ + "static/media/medium_depth_peels.08c359b9.pdf";